module.exports = __webpack_public_path__ + "static/media/office15.79c37316.png";